/* eslint-disable */
import Vue from 'vue'
import Element from 'element-ui'
import '../../assets/css/element-variables.scss'
import '../../assets/css/elementHack.scss'

Vue.use(Element)
